var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcArrowInCircleLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 41,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#83868A",
  clipPath: "url(#ic-arrow-in-circle-left_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 .5C8.95.5 0 9.45 0 20.5s8.95 20 20 20 20-8.95 20-20-8.95-20-20-20m0 38.333c-10.117 0-18.333-8.216-18.333-18.333S9.883 2.167 20 2.167 38.333 10.383 38.333 20.5 30.117 38.833 20 38.833"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.217 19.667h-12.4l4.616-4.617a.825.825 0 0 0 0-1.183.825.825 0 0 0-1.183 0l-6.05 6.05s-.133.167-.183.267a.83.83 0 0 0 0 .633c.05.1.1.2.183.267l6.05 6.05a.84.84 0 0 0 .583.25c.2 0 .434-.084.584-.25a.825.825 0 0 0 0-1.183L14.8 21.334h12.4a.825.825 0 0 0 .833-.834.825.825 0 0 0-.833-.833z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-arrow-in-circle-left_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h40v40H0z"
})))));
export default SvgIcArrowInCircleLeft;